import React from 'react';
import { useParams } from 'react-router-dom';
import { Alert } from '@mui/material';

import BoxContainer from '../../../style-components/BoxContainer.jsx';
import HeaderContainer from '../../../style-components/HeaderContainer.jsx';

import LaminariaImageResourceDetail from './components/LaminariaImageResourceDetail.jsx';
import VideoResourceDetail from './components/VideoResourceDetail.jsx';
import AnatomicalStructureResourceDetail from './components/AnatomicalStructureResourceDetail/AnatomicalStructureResourceDetail.jsx';

import { resourcesConfig } from '../resourcesConfig.js';

/**
 * Wrapper de detalle: elige el componente dedicado según el tipo de recurso y le
 * pasa los props que necesita, extraídos del rastro de ids (`segments`).
 *
 * La forma del rastro por recurso:
 * - laminaria:              [laminariaId, sectionId, imageId]
 * - videos:                 [...carpetas, videoId]  (videoId es el último)
 * - anatomical-collections: [collectionId, structureId]
 *
 * Props:
 * - resourceType: clave del recurso.
 * - segments: rastro de ids desde la raíz hasta la hoja.
 * - backPath: ruta del listado que contiene la hoja.
 */
const renderResourceDetail = (resourceType, segments, backPath) => {
  switch (resourceType) {
    case 'laminaria':
      return (
        <LaminariaImageResourceDetail
          laminariaId={segments[0]}
          sectionId={segments[1]}
          imageId={segments[2]}
          backPath={backPath}
        />
      );
    case 'videos':
      return <VideoResourceDetail videoId={segments[segments.length - 1]} backPath={backPath} />;
    case 'anatomical-collections':
      return (
        <AnatomicalStructureResourceDetail
          collectionId={segments[0]}
          structureId={segments[1]}
          backPath={backPath}
        />
      );
    default:
      return () => <Alert severity='error'>Tipo de recurso no válido.</Alert>;
  }
};

const ResourceDetail = () => {
  const params = useParams();
  const resourceType = params.resourceType;
  const rest = params['*'] || '';
  const segments = rest.split('/').filter(Boolean);

  const config = resourcesConfig[resourceType];
  const label = config?.label || 'Recurso';

  const parentSegments = segments.slice(0, -1);
  const backPath = parentSegments.length
    ? `/resources/${resourceType}/${parentSegments.join('/')}`
    : `/resources/${resourceType}`;
  return (
    <BoxContainer>
      <div className='antialiased font-sans w-full'>
        <div className='divide-y divide-primary'>
          <HeaderContainer title={label} />
          <div className='py-8 px-4 sm:px-8 min-w-full w-full'>
            {renderResourceDetail(resourceType, segments, backPath)}
          </div>
        </div>
      </div>
    </BoxContainer>
  );
};

export default ResourceDetail;
